import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  // {
  //   path: '/test',
  //   name: 'test-page',
  //   component: () => import("../views/_dev_test.vue"),
  // },

  {
    path: "/s/:code",
    name: "short-link",
    component: () => import("../views/shortLink/index.vue"),
  },
  // Chat
  {
    path: "/",
    component: () => import("../views/chatroom/index.vue"),
    children: [
      {
        path: "/redirect",
        name: "redirect",
        component: () => import("../views/_redirect.vue"),
      },
      {
        path: "/selectCountry",
        name: "select-country",
        component: () => import("../views/_selectCountry.vue"),
      },
      {
        path: "/connecting",
        name: "connecting",
        component: () => import("../views/connecting.vue"),
      },
      {
        path: "/error",
        name: "error-page",
        component: () => import("../views/error.vue"),
      },

      {
        path: "",
        component: () => import("../views/chatroom/process/index.vue"),
        children: [
          {
            path: "",
            name: "select-skill",
            component: () =>
              import("../views/chatroom/process/_selectSkill.vue"),
          },
          {
            path: "/policy",
            name: "policy",
            component: () => import("../views/chatroom/process/policy.vue"),
          },
          {
            path: "/workoff",
            name: "workoff",
            component: () => import("../views/chatroom/process/workoff.vue"),
          },
          {
            path: "/unService",
            name: "unService",
            component: () => import("../views/chatroom/process/unService.vue"),
          },
          {
            path: "/survey",
            name: "chatroom-entry",
            component: () => import("../views/chatroom/process/survey.vue"),
          },

          {
            path: "/BBY",
            name: "BBY",
            component: () => import("../views/chatroom/process/BBY.vue"),
          },
          {
            path: "/inWarranty",
            name: "inWarranty",
            component: () => import("../views/chatroom/process/inWarranty.vue"),
          },

          {
            path: "/waitting",
            name: "waitting",
            component: () => import("../views/chatroom/process/waitting.vue"),
          },
          {
            path: "/chatClose",
            name: "chatClose",
            component: () => import("../views/chatroom/process/chatClose.vue"),
          },
          {
            path: "/chatEnd",
            name: "chatEnd",
            component: () => import("../views/chatroom/process/chatEnd.vue"),
          },
          {
            path: "/surveyDone",
            name: "surveyDone",
            component: () => import("../views/chatroom/process/surveyDone.vue"),
          },
          {
            path: "/PostRepairSupport",
            name: "PostRepairSupport",
            component: () =>
              import("../views/chatroom/process/PostRepairSupport.vue"),
          },
        ],
      },
      {
        path: "/chatroom/:id",
        name: "chatroom",
        component: () => import("../views/chatroom/_id.vue"),
      },
      {
        path: "/videoCall",
        name: "videoCall",
        component: () => import("../views/videoCall/index.vue"),
      },
      {
        path: "/videoCall/rtc",
        name: "videoCall-webrtc",
        component: () => import("../views/videoCall/RTC.vue"),
      },
      {
        path: "/videoCallEnd",
        name: "videoCallEnd",
        component: () => import("../views/videoCallEnd.vue"),
      },
    ],
  },
  // Chat GPT
  {
    path: "/gpt",
    component: () => import("../views/gpt/index.vue"),
    children: [
      {
        path: "",
        name: "gpt-entrance",
        component: () => import("../views/gpt/entrance.vue"),
      },
      {
        path: "/gpt/chat_history/:id",
        name: "chat-history",
        component: () => import("../views/gpt/history/_chat.vue"),
      },
      {
        path: "/gpt/bot_history/:id",
        name: "bot-history",
        component: () => import("../views/gpt/history/_bot.vue"),
      },
      {
        path: "/gpt/survey",
        name: "gpt-survey",
        component: () => import("../views/gpt/survey.vue"),
      },
      {
        path: "/gpt/end",
        name: "gpt-end",
        component: () => import("../views/gpt/end.vue"),
      },
      {
        path: "/gpt/survey_end",
        name: "gpt-survey-end",
        component: () => import("../views/gpt/survey_end.vue"),
      },
      {
        path: "/gpt/:id",
        name: "gpt-room",
        component: () => import("../views/gpt/_id.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  // mode: 'history', // abstract
  routes,
});

// 路由守衛
router.beforeEach((to, from, next) => {
  next();
});

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

export default router;
